import Typography from "@mui/material/Typography";
import List from "@mui/material/List";
import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";
import CustomCard from "../../../../../../../../modules/atoms/cards/main";
import AvatarListShimmer from "../../../../../../../../modules/molecules/shimmer/List/main";
import ListTile from "../../../../../../../../modules/molecules/ListTile/main";
import { convertToTitleCase } from "../../../../../../../../config/config";
import Icon from "../../../../../../../../icons/main";
import { WrapperType } from "./wrapper.type";
import { memo } from "react";

const Wrapper = ({
  isError,
  isLoading,
  isFetching,
  listData,
  refetch,
}: WrapperType) => {
  if (isError && !isFetching) {
    return (
      <Grid
        item
        container
        alignContent={"flex-start"}
        data-testid="topAgent-onerror"
      >
        <Grid item xs={12}>
          <Typography
            data-testid="topAgent-heading"
            variant="subtitle1"
            sx={{ marginLeft: "1.625rem", fontSize: "0.875rem" }}
          >
            Top Performing survey agents
          </Typography>
        </Grid>
        <Grid item xs={12}>
          <CustomCard
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              width: "90%",
              height: "200px",
              backgroundColor: "rgba(0, 0, 0, 0.11)",
              borderRadius: "1rem",
            }}
          >
            {Icon["refresh"](refetch)}
          </CustomCard>
        </Grid>
      </Grid>
    );
  }
  return (
    <Grid item container>
      <Grid item xs={12}>
        <Typography
          variant="subtitle1"
          sx={{ marginLeft: "1.625rem", fontSize: "0.875rem" }}
          data-testid="topAgent-heading"
        >
          Top Performing survey agents
        </Typography>
      </Grid>
      <Grid
        item
        xs={12}
        sx={{
          maxHeight: "600px",
          overflowY: "scroll",
        }}
      >
        <Box sx={{ height: "800px" }}>
          {isLoading || isFetching ? (
            <AvatarListShimmer
              avatarVarient="circular"
              enableSubtitle={true}
              avatarStyle={{}}
            />
          ) : listData.length === 0 ? (
            <Typography
              variant="subtitle2"
              sx={{ marginLeft: "1.625rem" }}
              data-testid="topAgent-nodata"
            >
              No Data found
            </Typography>
          ) : (
            <List
              sx={{
                width: "100%",
                maxWidth: 360,
                bgcolor: "background.paper",
              }}
              data-testid="topAgent-list"
            >
              {listData.length > 0 &&
                listData.map((e) => (
                  <ListTile
                    title={
                      e.user_full_name.trim() !== ""
                        ? convertToTitleCase(e.user_full_name)
                        : ""
                    }
                    avatarType="image"
                    avatarSrc="#"
                    altText={
                      e.user_full_name.trim() !== ""
                        ? e?.user_full_name[0]?.toUpperCase()
                        : ""
                    }
                    alignItems="center"
                    subtitle=""
                    key={e.user_id}
                  />
                ))}
            </List>
          )}
        </Box>
      </Grid>
    </Grid>
  );
};

export default memo(Wrapper);
